import { createContext, useContext } from "react";

/**
 * The redesign switch (RD-08, Paul 2026-10-14): Anthony's five-item nav and Home show
 * only where the server says so, `features.redesign_nav` on `/api/profile/me/` (#1985:
 * `REDESIGN_NAV_ENABLED` on dev, or a named account). Everywhere else the app is exactly
 * what prod runs today: the old sidebar, More, the Dashboard and the profile menu.
 *
 * "unknown" while a signed-in profile is still loading, so a route can wait instead of
 * flashing the wrong page; the shell treats it as off. The provider is
 * `components/redesign/RedesignNavProvider`.
 */
export type RedesignNavState = "on" | "off" | "unknown";

export const RedesignNavContext = createContext<RedesignNavState>("off");

export function useRedesignNavState(): RedesignNavState {
  return useContext(RedesignNavContext);
}

/** True only when the server switch is on for this account. */
export function useRedesignNav(): boolean {
  return useContext(RedesignNavContext) === "on";
}
